(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutcars-category-cards"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nutcars-carousel')) {
  customElements.define('nutcars-carousel', class extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('[data-track]');
      const prev = this.querySelector('.nc-cats__nav--prev');
      const next = this.querySelector('.nc-cats__nav--next');
      if (!track) return;

      const step = () => {
        const card = track.querySelector('.nc-cats__card');
        if (!card) return track.clientWidth * 0.8;
        const styles = getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap || '0');
        return card.offsetWidth + gap;
      };

      const update = () => {
        const max = track.scrollWidth - track.clientWidth - 1;
        prev?.toggleAttribute('disabled', track.scrollLeft <= 0);
        next?.toggleAttribute('disabled', track.scrollLeft >= max);
      };

      prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));

      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      requestAnimationFrame(update);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutcars-flash-deal"] && !Shopify.designMode) return;
  try {
    
(function(){
  const roots = document.querySelectorAll('[data-nc-countdown]');
  roots.forEach(function(root){
    const eod = root.hasAttribute('data-nc-countdown-eod');
    const deadline = root.getAttribute('data-deadline');
    // Next local midnight (00:00) = end of the current day.
    function nextMidnight(){
      const d = new Date();
      d.setHours(24, 0, 0, 0);
      return d.getTime();
    }
    let target = eod ? nextMidnight() : new Date(deadline).getTime();
    if (isNaN(target)) return;
    const elHours = root.querySelector('[data-nc-countdown-hours]');
    const elMinutes = root.querySelector('[data-nc-countdown-minutes]');
    const elSeconds = root.querySelector('[data-nc-countdown-seconds]');
    const pad = function(n){ return String(Math.max(0, n)).padStart(2, '0'); };
    function tick(){
      let diff = target - Date.now();
      if (diff <= 0){
        if (eod){ target = nextMidnight(); diff = target - Date.now(); }
        else {
          elHours.textContent = '00';
          elMinutes.textContent = '00'; elSeconds.textContent = '00';
          return;
        }
      }
      const s = Math.floor(diff/1000);
      elHours.textContent = pad(Math.floor(s/3600));
      elMinutes.textContent = pad(Math.floor(s/60)%60);
      elSeconds.textContent = pad(s%60);
    }
    tick();
    setInterval(tick, 1000);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
